function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "current",
  d: "M22.0078 5H2.00781V7H22.0078V5ZM4.00781 13H2.00781V15H4.00781V13ZM4.00781 9H6.00781V11H4.00781V9ZM6.00781 17H4.00781V19H6.00781V17ZM10.0078 13H12.0078V15H10.0078V13ZM14.0078 9H12.0078V11H14.0078V9ZM12.0078 17H14.0078V19H12.0078V17ZM20.0078 13H18.0078V15H20.0078V13ZM20.0078 9H22.0078V11H20.0078V9ZM22.0078 17H20.0078V19H22.0078V17ZM6.00781 13H8.00781V15H6.00781V13ZM10.0078 9H8.00781V11H10.0078V9ZM8.00781 17H10.0078V19H8.00781V17ZM16.0078 13H14.0078V15H16.0078V13ZM16.0078 9H18.0078V11H16.0078V9ZM18.0078 17H16.0078V19H18.0078V17Z"
});

function SvgSoil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSoil);
export default __webpack_public_path__ + "static/media/Soil.a86fd515.svg";
export { ForwardRef as ReactComponent };